<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="events"
      :items-per-page="15"
      dense
      item-key="id"
      elevation="0"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-5">
          <v-toolbar-title>{{ events.length ? events[0].date: '' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-3"
            icon
            outlined
            small
            @click="$emit('close')"
            class="mr-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.status="{ item }">
        <v-btn :class="getEventStatusFillings(item)['class']">
          {{ getEventStatusFillings(item)['label'] }}
        </v-btn>
      </template>
      <template v-slot:item.is_night_schedule="{ item }">
        <v-btn :class="item.is_night_schedule ? 'blue-grey darken-3 white--text' : 'yellow' ">
          {{ item.is_night_schedule ? 'Ночь' : 'День' }}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn @click.stop="openDialog(item)">
          OPen
        </v-btn>
      </template>
    </v-data-table>
    <EventDialogForm
      v-if="selectedEvent"
      :eventId="selectedEvent"
      @close-dialog="closeDialog()"
    />
  </v-card>
</template>

<script>
import EventDialogForm from "@/components/departments/EventDialogForm";
export default {
  name: "DepartmentCashshiftEventsTable",
  components: {EventDialogForm},
  props: {
    events: Array
  },
  data: () => ({
    headers: [
      { text: "День", align: "center", value: "date" },
      { text: "Сотрудник", align: "center", value: "employee.fullname" },
      { text: "Позиция", align: "center", value: "employee.role" },
      { text: "Оклад", align: "center", value: "regular" },
      { text: "Бонус", align: "center", value: "bonus" },
      { text: "Статус", align: "center", value: "status" },
      { text: "...", align: "center", value: "actions" },
    ],
    selectedEvent: null
  }),
  methods: {
    closeDialog() {
      this.selectedEvent = null
    },
     getEventStatusFillings(item) {
      if (item.is_confirmed && item.status) {
        return {'label': 'Confirm', 'class': 'info'}
      }
      switch (true) {
        case (item.status === 0):
          return {'label': 'OK', 'class': 'success'}
        case (item.status === 1):
          return {'label': 'Не полный день', 'class': 'warning'}
        case (item.status === 2):
          return {'label': 'Несколько явок', 'class': 'alert'}
      }
    },
    openDialog(item) {
      this.selectedEvent = item.id
      this.eventDialogForm = true
    },
  }
}
</script>

<style scoped>

</style>